import { createReducer, on } from '@ngrx/store';
import { GetRolesSuccess } from '../actions/roles.actions';

export interface RolesState {
  roles: any;
}

const initialState: RolesState = {
  roles: {},
};

export const RolesReducer = createReducer(
  initialState,
  on(GetRolesSuccess, (state, { roles }) => ({
    ...state,
    roles: typeof roles === 'string' ? JSON.parse(roles) : roles?.userPermissions || roles,
  })),
);
